
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize&sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-0b375081\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./markdown-header.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./markdown-header.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-0b375081\"}!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./markdown-header.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/markdown-header/markdown-header.vue
// module id = 270
// module chunks = 1